module.exports = __webpack_public_path__ + "img/slide-5-recognize-key-initiation-2.d02c9483.png";